import { httpRequest } from '@calendly/http-tools'

export const getMemberships = (params = {}) => httpRequest({
  url: '/api/organization/memberships',
  method: 'GET',
  params
})

export const getInvitations = (params = {}) => httpRequest({
  url: '/api/organization/invitations',
  method: 'GET',
  params
})

export const getMigrations = (params = {}) => httpRequest({
  url: '/api/organization/migrations',
  method: 'GET',
  params
})

export const setOwnership = (id) => httpRequest({
  url: '/api/organization/ownership',
  method: 'PUT',
  data: {
    user_id: id
  }
})

export const changeMembershipRoles = (memberIds, role) => httpRequest({
  url: '/api/organization/memberships/batch_change_role',
  method: 'PATCH',
  data: {
    ids: memberIds,
    role
  }
})

export const deleteInvitations = (invitationIds) => httpRequest({
  url: '/api/organization/invitations/batch_delete',
  method: 'DELETE',
  data: {
    ids: invitationIds
  }
})

export const deleteMembership = (membershipId) => httpRequest({
  url: `/api/organization/memberships/${membershipId}`,
  method: 'DELETE'
})

export const deleteUser = (userId) => httpRequest({
  url: `/api/organization/users/${userId}`,
  method: 'DELETE'
})

export const resendInvitation = (invitationId) => httpRequest({
  url: `/api/organization/invitations/${invitationId}/resend`,
  method: 'POST'
})

export const batchResendInvitations = (invitationIds, selectAll = false, excludedIds = []) => httpRequest({
  url: '/api/organization/invitations/batch_resend',
  method: 'POST',
  data: selectAll ? { resendToAllUsers: true, excludedIds } : { ids: invitationIds }
})

export const batchDeleteMemberships = (membershipIds) => httpRequest({
  url: '/api/organization/memberships/batch_destroy',
  method: 'DELETE',
  data: { ids: membershipIds }
})

export const batchDeleteUsers = (userIds) => httpRequest({
  url: '/api/organization/users/batch_destroy',
  method: 'DELETE',
  data: { ids: userIds }
})
